module.exports = __webpack_public_path__ + "static/media/sp44.e6a3973d.JPG";